export const FRONTEND_MESSAGES = {
  browserNotSupported: '지원되지 않는 브라우저입니다.',
  encodingOrAccessDenied: '인코딩에 실패했거나 접근 제한되어 재생할 수 없습니다.',
  playbackCompleted: '미디어 재생이 완료되었습니다.',
  secureContentUnavailable: '해당 콘텐츠는 암호화되어 재생할 수 없습니다.',
  secureKeyRequestInvalid: '잘못된 요청입니다.',
  secureKeyPasswordTitle: '재생 암호 오류',
  passwordRetryExceeded: '최대 비밀번호 입력 횟수를 초과하였습니다.',
  passwordTitle: '비밀번호 오류',
  passwordPromptTitle: '재생 암호를 입력해주세요',
  passwordPromptLabel: '비밀번호를 입력해주세요',
  passwordPromptInvalid: '비밀번호가 올바르지 않습니다',
  passwordPromptPlaceholder: '재생 암호',
  confirm: '확인',
  chat: '채팅',
  drmRetrying: 'DRM 인증을 재시도 합니다.',
} as const;
